const l = {
  name: "Estonia",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,12c0,0.5-0.4,1-1,1s-1-0.5-1-1c0-0.6,0.4-1,1-1S13,11.5,13,12z"/>
		<path class="st0" d="M9.9,6.9l1.5-1.2h1.2l1.5,1.2L16,7.1L16.9,8l0.2,1.9l1.2,1.5v1.2l-1.2,1.5L16.9,16L16,16.9l-1.9,0.2l-1.5,1.2
			h-1.2l-1.5-1.2L8,16.9L7.1,16l-0.2-1.9l-1.2-1.5v-1.2l1.2-1.5L7.1,8L8,7.1L9.9,6.9z M12,7.8l-1.1,0.9l-0.5,0.2L9,9l-0.2,1.4
			l-0.2,0.5L7.8,12l0.9,1.1l0.2,0.5L9,15l1.4,0.2l0.5,0.2l1.1,0.9l1.1-0.9l0.5-0.2L15,15l0.2-1.4l0.2-0.5l0.9-1.1l-0.9-1.1l-0.2-0.5
			L15,9l-1.4-0.2l-0.5-0.2L12,7.8z"/>
		<path class="st0" d="M9.4,2.2l1.9-1.9h1.4l1.9,1.9l2.6-0.7l1.2,0.7l0.7,2.6l2.6,0.7l0.7,1.2l-0.7,2.6l1.9,1.9v1.4l-1.9,1.9
			l0.7,2.6l-0.7,1.2l-2.6,0.7l-0.7,2.6l-1.2,0.7l-2.6-0.7l-1.9,1.9h-1.4l-1.9-1.9l-2.6,0.7l-1.2-0.7l-0.7-2.6l-2.6-0.7l-0.7-1.2
			l0.7-2.6l-1.9-1.9v-1.4l1.9-1.9L1.5,6.8l0.7-1.2l2.6-0.7l0.7-2.6l1.2-0.7L9.4,2.2z M12,2.4L10.4,4l-1,0.3L7.2,3.7L6.6,5.9L5.9,6.6
			L3.7,7.2l0.6,2.2l-0.3,1L2.4,12L4,13.6l0.3,1l-0.6,2.2l2.2,0.6l0.7,0.7l0.6,2.2l2.2-0.6l1,0.3l1.6,1.6l1.6-1.6l1-0.3l2.2,0.6
			l0.6-2.2l0.7-0.7l2.2-0.6l-0.6-2.2l0.3-1l1.6-1.6L20,10.4l-0.3-1l0.6-2.2l-2.2-0.6l-0.7-0.7l-0.6-2.2l-2.2,0.6l-1-0.3L12,2.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as Estonia
};
